let pluginManager = new ContaoWebpack.PluginManager();

window.swPluginManager = pluginManager;

import SwScrollInverter from "./plugins/ScrollInverter/inverter.plugin";
import SwScrollTo from "./plugins/ScrollTo/scrollto.plugin";
import SwVisibleAfter from "./plugins/VisibleAfter/visibleafter.plugin";
import SwClassAfter from "./plugins/ClassAfter/classafter.plugin";
import SwConsentBar from "./plugins/ConsentBar/consent.plugin";
import SwNavigationAccordion from "./plugins/NavigationAccordion/accordion.plugin";
import SwTouchNavigation from "./plugins/TouchNavigation/touch.plugin";
import "./scroll-to-footer-hide.js";

pluginManager.registrate(
    "SwScrollInverter",
    SwScrollInverter,
    "[data-sw-scroll-inverter]",
);
pluginManager.registrate("SwScrollTo", SwScrollTo, "[data-sw-scroll-to]");
pluginManager.registrate(
    "SwVisibleAfter",
    SwVisibleAfter,
    "[data-sw-visible-after]",
);
pluginManager.registrate("SwClassAfter", SwClassAfter, "[data-sw-class-after]");
pluginManager.registrate("SwConsentBar", SwConsentBar, "[data-sw-consent-bar]");
pluginManager.registrate(
    "SwNavigationAccordion",
    SwNavigationAccordion,
    ".tz-navigation-sports",
);
pluginManager.registrate(
    "SwTouchNavigation",
    SwTouchNavigation,
    "header .mod_navigation",
);

pluginManager.init();
